import { GamerFAQItem } from '../data/faqData'
import FAQAskedQuestions from '../../../components/FAQ/FAQAskedQuestions'

interface FAQAskedQuestionsGamerProps {
  faqItems: GamerFAQItem[]
}

export default function FAQAskedQuestionsGamer({ faqItems }: FAQAskedQuestionsGamerProps) {
  return (
    <FAQAskedQuestions
      faqItems={faqItems}
      titleKey="gamer.faq.frequentlyAskedQuestions"
      searchPlaceholderKey="gamer.faq.searchPlaceholder"
      noResultsKey="gamer.faq.noResults"
    />
  )
}
